import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 0 10px;
  flex: 1;
`;

export const Text = styled(TextLayoutComponent)`
  width: 60px;
  text-align: left;
`;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown > .text {
    width: 70px;
    ${({ flex }) => flex && flex === 5 && 'width: 200px;'}
    ${({ flex }) => flex && flex === 3 && 'width: 130px;'}
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.ui.dropdown {
    min-width: unset;
    flex: ${({ flex }) => flex};
  }
`;

export const DinamicContainer = styled.div`
  display: flex;
  flex-direction: ${({ revert }) => (revert ? 'row-reverse' : 'row')};
  gap: 10px;
`;

export const OperatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 40px;
`;

export const Operator = styled.a`
  cursor: pointer;
`;
